import { createApp } from 'vue'
import options from './StickySliderElement.options'

const el = '.kb-component--sticky-slider-element'

export default function (Store) {
    const DOM = document.querySelector(el)
    if (DOM) {
        const template = DOM.innerHTML
        options.template = template
        const component = createApp(options).use(Store)
        component.mount(el)
    }
}
